import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ec600f00"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Notes", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " This is a test of an XML CRDT integration with prosemirror for a fully P2P document system. The goal is to achieve the benefits of a P2P relationship, such as offline editing, security, and ownership, without sacrificing the uptime of a client-server relationship. ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Characteristics:")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Changes in arbitrary order merge to the same result"),
  /*#__PURE__*/_createElementVNode("li", null, "Merged changes preserve intention"),
  /*#__PURE__*/_createElementVNode("li", null, "Changes can reasonably expect to propagate across the network")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Soundboard", -1))
const _hoisted_7 = { class: "operations-list" }
const _hoisted_8 = { class: "" }
const _hoisted_9 = { class: "font-bold border-b border-type" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "relative" }, "Alpha Snapshot", -1))
const _hoisted_14 = { class: "operations-list" }
const _hoisted_15 = { style: { 'align-items': 'start' } }
const _hoisted_16 = {
  key: 0,
  class: "operations-list"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "font-bold" }, "clock", -1))
const _hoisted_18 = ["max", "value", "onInput"]
const _hoisted_19 = {
  key: 1,
  class: "operations-list overflow-auto",
  style: { 'max-height': '180px' }
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "font-bold" }, "delete set", -1))
const _hoisted_21 = ["onUpdate:modelValue"]
const _hoisted_22 = {
  class: "",
  ref: "snapshot"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "States:", -1))
const _hoisted_24 = { class: "border-b border-type" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "font-bold" }
const _hoisted_27 = ["onUpdate:modelValue"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["onUpdate:modelValue"]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "*current version:", -1))
const _hoisted_32 = { class: "" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "current version:", -1))
const _hoisted_34 = { class: "" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "current state:", -1))
const _hoisted_36 = { class: "" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "accepted version:", -1))
const _hoisted_38 = { class: "" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "acknowledged version:", -1))
const _hoisted_40 = { class: "" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "acknowledged state:", -1))
const _hoisted_42 = { class: "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _hoisted_6,
    _createElementVNode("ul", _hoisted_7, [
      _createElementVNode("li", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ids, (id) => {
          return (_openBlock(), _createElementBlock("ul", {
            class: "operations-list flex-grow",
            key: id
          }, [
            _createElementVNode("li", _hoisted_9, _toDisplayString(id), 1),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                type: "button",
                onClick: ($event: any) => (_ctx.logDoc(id))
              }, "log doc", 8, _hoisted_10)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                type: "button",
                onClick: ($event: any) => (_ctx.logView(id))
              }, "log view", 8, _hoisted_11)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                type: "button",
                onClick: ($event: any) => (_ctx.logSnapshot(id))
              }, "log snapshot", 8, _hoisted_12)
            ])
          ]))
        }), 128))
      ])
    ]),
    _hoisted_13,
    _createElementVNode("ul", _hoisted_14, [
      _createElementVNode("li", _hoisted_15, [
        (
            _ctx.measurements['Alpha']['clock'] &&
            _ctx.measurements['Alpha']['clock'].keys
          )
          ? (_openBlock(), _createElementBlock("ul", _hoisted_16, [
              _hoisted_17,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.measurements['Alpha']['clock'].keys(), (timeline) => {
                return (_openBlock(), _createElementBlock("li", { key: timeline }, [
                  _createTextVNode(_toDisplayString(timeline) + " => " + _toDisplayString(_ctx.measurements["Alpha"]["snapshot-clock"].get(timeline)) + " ", 1),
                  _createElementVNode("input", {
                    type: "range",
                    style: { 'min-width': '0px' },
                    min: 0,
                    max: _ctx.measurements['Alpha']['clock'].get(timeline),
                    value: _ctx.measurements['Alpha']['snapshot-clock'].get(timeline),
                    onInput: 
                (event) => {
                  _ctx.measurements['Alpha']['snapshot-clock'].set(
                    timeline,
                    event.target.value
                  );
                  _ctx.renderPruning();
                }
              
                  }, null, 40, _hoisted_18)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (
            _ctx.measurements['Alpha']['delete-set'] &&
            _ctx.measurements['Alpha']['delete-set'].clients
          )
          ? (_openBlock(), _createElementBlock("ul", _hoisted_19, [
              _hoisted_20,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array.from(
              _ctx.measurements['Alpha']['delete-set'].clients.keys()
            ), (client) => {
                return (_openBlock(), _createElementBlock("div", { key: client }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.measurements['Alpha'][
                'delete-set'
              ].clients.get(client), (item, i) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: item.clock
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": ($event: any) => ((
                  _ctx.measurements['Alpha']['snapshot-delete-set'][client][i]
                ) = $event),
                        class: "flex-none",
                        onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.renderPruning()))
                      }, null, 40, _hoisted_21), [
                        [_vModelCheckbox, 
                  _ctx.measurements['Alpha']['snapshot-delete-set'][client][i]
                ]
                      ]),
                      _createTextVNode(" " + _toDisplayString(client) + " => { " + _toDisplayString(item.clock) + ": " + _toDisplayString(item.len) + " } ", 1)
                    ]))
                  }), 128))
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_22, null, 512),
    _hoisted_23,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ids, (id) => {
      return (_openBlock(), _createElementBlock("ul", {
        class: "operations-list flex-grow",
        key: id
      }, [
        _createElementVNode("li", _hoisted_24, [
          _createElementVNode("input", {
            type: "checkbox",
            value: "measurements[id]['online']",
            onClick: ($event: any) => (_ctx.toggleOnline(id)),
            class: "flex-none"
          }, null, 8, _hoisted_25),
          _createElementVNode("label", _hoisted_26, _toDisplayString(id), 1),
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            "onUpdate:modelValue": ($event: any) => ((_ctx.measurements[id]['passive-pull']) = $event),
            class: "flex-none"
          }, null, 8, _hoisted_27), [
            [_vModelCheckbox, _ctx.measurements[id]['passive-pull']]
          ]),
          _createElementVNode("button", {
            class: _normalizeClass(["text-sm", { disabled: _ctx.measurements[id]['passive-pull'] }]),
            onClick: ($event: any) => (_ctx.pull(id))
          }, " pull ", 10, _hoisted_28),
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            "onUpdate:modelValue": ($event: any) => ((_ctx.measurements[id]['passive-stage']) = $event),
            class: "flex-none"
          }, null, 8, _hoisted_29), [
            [_vModelCheckbox, _ctx.measurements[id]['passive-stage']]
          ]),
          _createElementVNode("button", {
            class: _normalizeClass(["text-sm", { disabled: _ctx.measurements[id]['passive-stage'] }]),
            onClick: ($event: any) => (_ctx.stage(id))
          }, " stage ", 10, _hoisted_30)
        ]),
        _createElementVNode("li", null, [
          _hoisted_31,
          _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.measurements[id]["*current-version"]), 1)
        ]),
        _createElementVNode("li", null, [
          _hoisted_33,
          _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.measurements[id]["current-version"]), 1)
        ]),
        _createElementVNode("li", null, [
          _hoisted_35,
          _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.measurements[id]["current-state"]), 1)
        ]),
        _createElementVNode("li", null, [
          _hoisted_37,
          _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.measurements[id]["accepted-version"]), 1)
        ]),
        _createElementVNode("li", null, [
          _hoisted_39,
          _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.measurements[id]["acknowledged-version"]), 1)
        ]),
        _createElementVNode("li", null, [
          _hoisted_41,
          _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.measurements[id]["acknowledged-state"]), 1)
        ])
      ]))
    }), 128))
  ]))
}